export default "__VITE_ASSET__CL3WbKFq__"